export default "__VITE_ASSET__BuvJBhrR__"